import React, { useEffect, useState } from "react";
import _ from "lodash";

import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import "./like-property.css";
import { CircularProgress } from "@mui/material";
import { dislikePropertyApi, likePropertyApi } from "../../../api/propertyApi";
import { ReactComponent as Heart } from "../../../assets/heart.svg";

const LikeProperty = ({ propertyId = null, isLiked = null, handleLike: _handleLike }) => {
  const auth = useSelector((state) => state.auth?.access_token);
  const [liked, setLiked] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLiked(isLiked);
  }, [isLiked]);

  if (!auth || !propertyId || _.isNil(isLiked)) return null;

  async function handleLike() {
    setLiked(!liked);

    setLoading(true);

    const payload = {
      propertyId,
    };

    try {
      if (liked) {
        await dislikePropertyApi(payload);
      } else {
        await likePropertyApi(payload);
      }

      if (_handleLike) {
        _handleLike(propertyId, liked);
      }
    } catch (error) {
      toast.error(error.message ?? "Something went wrong on our end. Please try again later or contact support.");
      setLiked(!liked);
    } finally {
      setLoading(false);
    }
  }

  const color = liked ? { color: "var(--like-color-foreground)" } : { color: "transparent" };
  const proggressColor = !liked ? { color: "var(--like-color-foreground)" } : { color: "transparent" };
  const fillColor = !liked ? { fill: "transparent" } : { fill: "var(--like-color-foreground)" };

  return (
    <span className="like-property" id="like-property" onClick={handleLike}>
      {loading ? (
        <CircularProgress
          color="primary"
          size={20}
          style={{
            position: "relative",
            left: "1px",
            ...proggressColor,
          }}
        />
      ) : (
        <Heart style={{ ...color, width: "20px", height: "20px", fill: fillColor, strokeWidth: "2px" }} />
      )}
    </span>
  );
};

export default LikeProperty;
